/**
 * @flow
 * @relayHash a25a207c9a6ca2b2d1e6432ebf5c002a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ArticleDeleteInput = {
  id: string
};
export type ArticleDeleteMutationVariables = {|
  input: ArticleDeleteInput
|};
export type ArticleDeleteMutationResponse = {|
  +ArticleDelete: ?{|
    +error: ?string
  |}
|};
export type ArticleDeleteMutation = {|
  variables: ArticleDeleteMutationVariables,
  response: ArticleDeleteMutationResponse,
|};
*/


/*
mutation ArticleDeleteMutation(
  $input: ArticleDeleteInput!
) {
  ArticleDelete(input: $input) {
    error
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ArticleDeleteInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "ArticleDeleteInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "error",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ArticleDeleteMutation",
  "id": null,
  "text": "mutation ArticleDeleteMutation(\n  $input: ArticleDeleteInput!\n) {\n  ArticleDelete(input: $input) {\n    error\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ArticleDeleteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "ArticleDelete",
        "storageKey": null,
        "args": v1,
        "concreteType": "ArticleDeletePayload",
        "plural": false,
        "selections": [
          v2
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ArticleDeleteMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "ArticleDelete",
        "storageKey": null,
        "args": v1,
        "concreteType": "ArticleDeletePayload",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fc5f6c4ad39540e8e791af35e117aa2f';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/ArticleDeleteMutation.graphql.js